const getServiceDetailsStyles = theme => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  fontSize: theme.toRem(theme.typography.fontSize.XS),
  color: theme.palette.gray.main
});
const getServiceDetailsItemsStyles = isFirstItem => theme => ({
  fontSize: 'inherit',
  lineHeight: 'inherit',
  '&::before': {
    content: '" - "'
  },
  ...(!isFirstItem && {
    marginTop: theme.spacing(2)
  })
});

export { getServiceDetailsItemsStyles, getServiceDetailsStyles };
//# sourceMappingURL=ServiceDetailsStyles.js.map
